import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, FileQuestion } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center space-y-8">
        {/* 404 Illustration */}
        <div className="relative">
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-64 h-64 bg-gradient-to-br from-indigo-200 to-purple-200 rounded-full blur-3xl opacity-50"></div>
          </div>
          <div className="relative">
            <h1 className="text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 animate-pulse">
              404
            </h1>
          </div>
        </div>

        {/* Icon */}
        <div className="flex justify-center">
          <div className="bg-gradient-to-br from-indigo-500 to-purple-600 p-6 rounded-full shadow-2xl">
            <FileQuestion className="h-16 w-16 text-white" />
          </div>
        </div>

        {/* Message */}
        <div className="space-y-4">
          <h2 className="text-4xl font-bold text-gray-900">
            Page Not Found
          </h2>
          <p className="text-xl text-gray-600 max-w-md mx-auto">
            Oops! The page you're looking for doesn't exist. It might have been moved or deleted.
          </p>
        </div>

        {/* Action Button */}
        <div className="flex justify-center items-center pt-8">
          <Link to="/">
            <Button
              size="lg"
              className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2 px-8"
            >
              <Home className="h-5 w-5" />
              Back to Home
            </Button>
          </Link>
        </div>

        {/* Quick Links */}
        <div className="pt-12 border-t border-gray-200">
          <p className="text-sm text-gray-500 mb-4 font-semibold">
            Popular Tools:
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/split" className="text-sm text-indigo-600 hover:text-indigo-800 hover:underline transition-colors">
              Split PDF
            </Link>
            <span className="text-gray-300">•</span>
            <Link to="/merge" className="text-sm text-indigo-600 hover:text-indigo-800 hover:underline transition-colors">
              Merge PDF
            </Link>
            <span className="text-gray-300">•</span>
            <Link to="/json-beautifier" className="text-sm text-indigo-600 hover:text-indigo-800 hover:underline transition-colors">
              JSON Beautifier
            </Link>
            <span className="text-gray-300">•</span>
            <Link to="/case-converter" className="text-sm text-indigo-600 hover:text-indigo-800 hover:underline transition-colors">
              Case Converter
            </Link>
            <span className="text-gray-300">•</span>
            <Link to="/online-notepad" className="text-sm text-indigo-600 hover:text-indigo-800 hover:underline transition-colors">
              Notepad
            </Link>
          </div>
        </div>

        {/* Footer Note */}
        <div className="pt-8">
          <p className="text-xs text-gray-400">
            Error Code: 404 | Page Not Found
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
